import ContentElement from "./ContentElement";
import { ElementModel } from "@api/models";

export default function Description({
  body,
  descriptionType,
}: {
  body?: string;
  descriptionType?: number;
}) {
  const isNewEditor = descriptionType === 1;
  const bodyJson: ElementModel[] = isNewEditor ? JSON.parse(body || "[]") : [];
  return (
    <div className={"g-description" + (isNewEditor ? "" : "mode-old")}>
      {!isNewEditor && <div dangerouslySetInnerHTML={{ __html: body || "" }} />}
      {bodyJson.map((element, index) => (
        <ContentElement element={{ ...element }} key={index} />
      ))}
    </div>
  );
}
